/**
 * Source / citation anchor — wire shape used by the Source Drawer (A.11).
 *
 * Distinct from ``Citation`` (which lives on a Message): ``Source`` is the
 * resolvable, openable entity (document, email thread, web URL, chat
 * message) and is what the right-rail drawer renders.
 */

import { z } from "zod";
import { IsoTimestampSchema, UuidSchema } from "./common.js";

export const SourceTypeSchema = z.enum([
  "document",
  "email",
  "chat",
  "database",
  "web",
  "other",
]);
export type SourceType = z.infer<typeof SourceTypeSchema>;

export const SourceSchema = z.object({
  id: UuidSchema,
  source_type: SourceTypeSchema,
  anchor: z.string(),
  title: z.string().optional(),
  url: z.url().optional(),
  /** Free-form payload — schema varies per source_type (resolved client-side). */
  payload: z.record(z.string(), z.unknown()).optional(),
  resolved_at: IsoTimestampSchema.optional(),
});
export type Source = z.infer<typeof SourceSchema>;
